import { render, staticRenderFns } from "./WHO.vue?vue&type=template&id=12db3aec"
import script from "./WHO.vue?vue&type=script&lang=js"
export * from "./WHO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports